import React, { createContext, useContext, useState } from "react";
import { RingLoader } from "react-spinners";

// Large loader for full-screen loading
function Loader({ isLoading = false }) {
  if (!isLoading) {
    return null;
  }
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <RingLoader size={400} color='#69C4D3' loading={isLoading} />
    </div>
  );
}

// Small loader for smaller use cases (for example inside buttons or other smaller elements)
function LoaderSmall({ isLoading = false }) {
  return <RingLoader size={60} color='#69C4D3' loading={isLoading} />;
}

// Creating the context to manage loading state
const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      <Loader isLoading={isLoading} />
      {children}
    </LoaderContext.Provider>
  );
}

export { Loader, LoaderSmall, LoadingProvider };
